export default __webpack_public_path__ + "static/corporate-7d3ff21f1fd8412571ef905e95e8c353.jpeg";